import { Icon, RadioIcon, RadioOnIcon } from '@/components/icons/svg-icons';
import clsx from 'clsx';
import { voucherDropdownStyle } from '@/features/betslip/voucher/components/voucher-dropdown/voucher-dropdown.style';
import { useTranslations } from 'next-intl';
import { siteService } from '@/services/site.service';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';

type OddsBoostPromoVoucherProps = {
    isSelected: boolean;
	isDisabled: boolean;
	onClick: () => void;
};
export const OddsBoostPromoIcon = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	return <img src={siteService.combineImagePath('/images/promotion/odds-boost-promo/oddsboost-promo-icon.png', true, SiteConfigsData)} />
};
export const OddsBoostPromoVoucher = ({ isSelected, isDisabled, onClick }: OddsBoostPromoVoucherProps) => {
	const t = useTranslations('General');
	return (
		<div
			className="reward-select-voucher"
			data-disabled={isDisabled}
			onClick={onClick}
		>
			{
				isSelected ? <RadioOnIcon /> : <RadioIcon />
			}
			<div className="reward-select-voucher__text">
				<div className="reward-select-voucher__label">
					{t('lbl_RPOddsBooster')}
				</div>
				{
					isDisabled ? <div className={'reward-select-voucher__info'}>{t('lbl_oddslimitvou')}</div> : null
				}
			</div>
			<div className={
				clsx(
					'reward-select-voucher__promo-tag',
					{ [voucherDropdownStyle.disableStatus]: isDisabled }
				)}
			>
				<Icon name="gift" />{t('lbl_obp05')}
			</div>
		</div>
	);
}